import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './styles/main.css'
import 'tailwindcss/base.css'
import 'tailwindcss/components.css'
import 'tailwindcss/utilities.css'

// Font Awesome for icons
import '@fortawesome/fontawesome-free/css/all.min.css'

const app = createApp(App)
app.use(router)
app.mount('#app')
